export const CUSTOMER_PRODUCT_NAME = 'Transporeon Visibility';
export const BACKOFFICE_PRODUCT_NAME = 'BackOffice';
